import { useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import { PositionSelectSearch, S4sStatusSelect, StatusSelect } from "shared";
import { useNavigate, useSearchParams } from "react-router-dom";

export const MainPageHeader = ({ isAdmin }: { isAdmin: boolean }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchString, setSearchString] = useState(
    searchParams.get("text") || ""
  );
  const navigate = useNavigate();
  return (
    <Box
      bgcolor="background.paper"
      borderRadius="4px"
      p="15px"
      display="flex"
      gap={1.5}
      alignItems="center"
    >
      <Box display="flex" gap={1}>
        <StatusSelect
          value={+`${searchParams.get("status")}` || ""}
          onChange={(e) =>
            setSearchParams((prev) => {
              const { status, ...rest } = Object.fromEntries(prev);
              return {
                ...rest,
                ...(e.target.value ? { status: e.target.value } : {}),
              };
            })
          }
        />
        <PositionSelectSearch
          value={+`${searchParams.get("position")}` || ""}
          onChange={(e) =>
            setSearchParams((prev) => {
              const { position, ...rest } = Object.fromEntries(prev);
              return {
                ...rest,
                ...(e.target.value ? { position: e.target.value } : {}),
              };
            })
          }
        />
        <TextField
          value={searchString}
          onChange={(e) => setSearchString(e.target.value)}
          sx={{ height: 42, maxWidth: 231 }}
          fullWidth
          label="Поиск"
          onKeyDown={(ev) => {
            if (ev.key === "Enter") {
              ev.preventDefault();
              setSearchParams((prev) => {
                const { text, ...rest } = Object.fromEntries(prev);

                return {
                  ...rest,
                  ...(searchString ? { text: searchString } : {}),
                };
              });
            }
          }}
          InputProps={{
            endAdornment: (
              <>
                {searchString && (
                  <IconButton
                    onClick={() => {
                      setSearchParams((prev) => {
                        const { text, ...rest } = Object.fromEntries(prev);
                        return {
                          ...rest,
                        };
                      });
                      setSearchString("");
                    }}
                    size="small"
                  >
                    <ClearIcon />
                  </IconButton>
                )}
                <IconButton
                  onClick={() =>
                    setSearchParams((prev) => {
                      const { text, ...rest } = Object.fromEntries(prev);

                      return {
                        ...rest,
                        ...(searchString ? { text: searchString } : {}),
                      };
                    })
                  }
                  size="small"
                >
                  <SearchIcon />
                </IconButton>
              </>
            ),
          }}
          size="small"
        />
        <S4sStatusSelect
          value={
            searchParams.get("statusS4S")
              ? `${searchParams.get("statusS4S")}`
              : ""
          }
          onChange={(e) =>
            setSearchParams((prev) => {
              const { statusS4S, ...rest } = Object.fromEntries(prev);
              return {
                ...rest,
                ...(e.target.value ? { statusS4S: e.target.value } : {}),
              };
            })
          }
        />
        <TextField
          select
          key={searchParams.get("project")}
          value={searchParams.get("project") || ""}
          onChange={(e) =>
            setSearchParams((prev) => {
              const { project, ...rest } = Object.fromEntries(prev);
              return {
                ...rest,
                ...(e.target.value ? { project: e.target.value } : {}),
              };
            })
          }
          sx={{ height: 42, minWidth: 200 }}
          fullWidth
          label="Поиск по проекту"
          size="small"
        >
          <MenuItem value="">
            <em>Выберите проект</em>
          </MenuItem>
          <MenuItem value="Самокат">Самокат</MenuItem>
          <MenuItem value="Мегамаркет">Мегамаркет</MenuItem>
          <MenuItem value="Сберлогистика">Сберлогистика</MenuItem>
        </TextField>
      </Box>
      {isAdmin && (
        <Button
          disableElevation
          onClick={() => navigate(`/create/${window.location.search}`)}
          sx={{
            textTransform: "none",
            minWidth: 100,
            ml: "auto",
            fontWeight: 700,
          }}
          variant="contained"
          size="small"
        >
          Добавить
        </Button>
      )}
    </Box>
  );
};
